import React, { useEffect, useState } from "react";
import "./CreateCohortModel.scss";
import { Modal } from "react-bootstrap";
import exportimages from "../../../../assets/images/exportImages";
import { useDispatch } from "react-redux";
import {
  createCohortSlice,
  setCohortApplied,
  setMode,
  setSelectedCohort,
} from "../../../../rtk-query/features/cohort/cohortSlice";
import { HttpStatusCode } from "axios";
import { usePermissions } from "../../../../hooks/usePermissions";
import { useSubscription } from "../../../../hooks/useSubscription";
import { PRIVILEGES } from "../../../../utils/privileges";
import { COHORT_MODE } from "../CohortList/CohortList";

const containsEmoji = (value = "") => {
  return /[\p{Extended_Pictographic}]/u.test(value);
};

export const MODEL = {
  CREATE: "create",
  SUCCESS: "success",
};

export const CreateCohortModel = (props) => {
  const dispatch = useDispatch();
  const { hasPermission } = usePermissions();
  const { hasSubscription } = useSubscription();

  const [cohortTitle, setCohortTitle] = useState("");
  const [cohortDesc, setCohortDesc] = useState("");

  const [errors, setErrors] = useState({
    cohortTitle: "",
    cohortDesc: "",
  });

  const handleTitleChange = (e) => {
    const value = e.target.value;

    if (containsEmoji(value)) {
      setErrors((prev) => ({
        ...prev,
        cohortTitle: "Emojis are not allowed",
      }));
      return;
    }

    setErrors((prev) => ({ ...prev, cohortTitle: "" }));
    setCohortTitle(value);
  };

  const handleDescChange = (e) => {
    const value = e.target.value;

    if (containsEmoji(value)) {
      setErrors((prev) => ({
        ...prev,
        cohortDesc: "Emojis are not allowed",
      }));
      return;
    }

    setErrors((prev) => ({ ...prev, cohortDesc: "" }));
    setCohortDesc(value);
  };

  const createCohort = async () => {
    const response = await dispatch(
      createCohortSlice({
        cohortTitle,
        cohortDesc,
      }),
    );

    if (response?.payload?.statusCode === HttpStatusCode.Ok) {
      props?.setSwitchCreateModel(MODEL.SUCCESS);
      dispatch(setMode(COHORT_MODE.CUSTOM));
      dispatch(setCohortApplied(null));
      dispatch(setSelectedCohort(response?.payload?.data));
    }
  };

  useEffect(() => {
    if (props.switchCreateModel === MODEL.CREATE) {
      setCohortTitle("");
      setCohortDesc("");
      setErrors({ cohortTitle: "", cohortDesc: "" });
    }
  }, [props.switchCreateModel]);

  const isFormValid =
    cohortTitle && cohortDesc && !errors.cohortTitle && !errors.cohortDesc;

  return (
    <Modal {...props} animation aria-labelledby="contained-modal" centered>
      <Modal.Body className="cohort-modal">
        {props?.switchCreateModel === MODEL.CREATE ? (
          <div className="create-cohort-modal">
            <div className="modal-header">
              <div className="icon-outer-circle">
                <div className="icon-inner-circle">
                  <img alt="icon" src={exportimages.create_cohort_icon} />
                </div>
              </div>
            </div>

            <h2>Create Cohort</h2>
            <p className="subtitle">
              A bank cohort obtained by filtering is a group of banks selected
              based on demographics, asset size, and bank type for comparative
              analysis.
            </p>

            {/* Cohort Title */}
            <div className="form-group">
              <label>Add Cohort As</label>
              <input
                type="text"
                placeholder="Enter cohort name"
                value={cohortTitle}
                onChange={handleTitleChange}
              />
              {errors.cohortTitle && (
                <span className="error-text">{errors.cohortTitle}</span>
              )}
            </div>

            <div className="form-group">
              <label>Description</label>
              <textarea
                placeholder="Enter cohort description"
                value={cohortDesc}
                onChange={handleDescChange}
              />
              {errors.cohortDesc && (
                <span className="error-text">{errors.cohortDesc}</span>
              )}
            </div>

            <div className="actions">
              <button className="btn cancel" onClick={() => props.onHide()}>
                Cancel
              </button>

              {hasPermission(PRIVILEGES.CREATE_COHORT) && (
                <button
                  className="btn primary"
                  onClick={createCohort}
                  disabled={
                    !hasSubscription(PRIVILEGES.CREATE_COHORT) || !isFormValid
                  }
                >
                  Create Cohort
                </button>
              )}
            </div>
          </div>
        ) : (
          <div className="success-cohort-modal">
            <div className="modal-header">
              <div className="icon-outer-circle">
                <div className="icon-inner-circle">
                  <img alt="icon" src={exportimages.cohort_success_icon} />
                </div>
              </div>
            </div>

            <h2>Cohort Created Successfully</h2>
            <p className="subtitle">
              Cohort <strong>{cohortTitle}</strong> was created successfully.
            </p>

            <div className="actions">
              <button className="btn cancel" onClick={() => props.onHide()}>
                Close
              </button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
